// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { BurnRequest } from '@daml.js/utility-registry-app-v0/lib/Utility/Registry/App/V0/Model/Burn';
import { BurnRequest_Cancel } from '@daml.js/utility-registry-v0/lib/Utility/Registry/V0/Holding/Burn';
import { ContractId } from '@daml/types';
import { ERR_CAN_BURN, SUC_CAN_BURN } from '../../../../utils/strings';

interface Args {
  burnRequestId: ContractId<BurnRequest>;
  reason?: string;
}

export const useCancelBurnRequest2Step = () => {
  const { submit: cancelBurnRequest } = useExerciseSubmission(
    BurnRequest.BurnRequest_Cancel,
    SUC_CAN_BURN,
    ERR_CAN_BURN,
  );

  return async (args: Args) => {
    const { burnRequestId } = args;

    const payload: BurnRequest_Cancel = {};

    const disclosedContracts: never[] = [];

    await cancelBurnRequest({
      cid: burnRequestId,
      argument: payload,
      meta: {
        disclosedContracts,
      },
    });
  };
};
